module.exports = __webpack_public_path__ + "static/media/pe.3e583c34.svg";